import { jsx as _jsx } from "react/jsx-runtime";
import usePagination from '@mui/material/usePagination';
import { PaginationItemWrapper, PaginationWrapper } from './styles';
import { PaginationItem } from './PaginationItem';
export var PaginationBase = function (_a) {
    var onPageChange = _a.onPageChange, pageCount = _a.pageCount, selectedPage = _a.selectedPage;
    var rawPaginationItems = usePagination({
        page: selectedPage,
        count: pageCount,
    }).items;
    var paginationDataList = rawPaginationItems.filter(function (item) { return item.page !== null; });
    return (_jsx(PaginationWrapper, { children: paginationDataList &&
            paginationDataList.map(function (paginationData, index) {
                return (_jsx(PaginationItemWrapper, { children: _jsx(PaginationItem, { paginationData: paginationData, onPageChange: onPageChange, selectedPage: selectedPage }) }, index));
            }) }));
};
